import React, { useEffect, useState } from "react";
import { emailValidate, passwordValidate } from "utils/CommonUtils";

import "style/ModalStyles.css";
import MsgModal from "./MsgModal";
import { requestPost } from "utils/AxiosApi";
const EditPasswordModal = (props: any) => {
  //모달창 open
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [modalKind, setModalKind] = useState("I");

  useEffect(() => {
    document.body.style.cssText = `
          position: fixed; 
          top: -${window.scrollY}px;
          overflow-y: scroll;
          width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);

  const setRegInputsData = (name: any, value: any) => {
    setRegInputs({
      ...regInputs,
      [name]: value,
    });
  };

  const [regInputs, setRegInputs] = useState({
    nowPassword: "",
    password: "",
  });

  const { nowPassword, password } = regInputs;

  const [passwordValid, setPassworeValid] = useState(true);
  const [passwordChkValid, setPassworeChkValid] = useState(true);

  const [emptyinputs, setEmptyinputs] = useState("");
  const [pwchk, setPwchk] = useState("");

  const inputChange = (e: any) => {
    const { value, name } = e.target;
    setRegInputsData(name, value);
  };

  const inputPwchk = (e: any) => {
    setPassworeChkValid(true);
    setPwchk(e.target.value);
  };

  const isEmpty = (value: any) => {
    if (value.length > 0) {
      return false;
    }
    return true;
  };

  const checkEmptyInput = () => {
    var submitInput = false;

    if (isEmpty(regInputs.nowPassword)) {
      setModalOpen(true);
      setModalMsg("새 비밀번호를 입력해주세요");
      setEmptyinputs("nowPassword");
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.password)) {
      setEmptyinputs("pw");
      setModalOpen(true);
      setModalMsg("새 비밀번호를 입력해주세요");
      return submitInput;
    } else if (
      !passwordValidate(regInputs.password, setModalOpen, setModalMsg)
    ) {
      // alert("비밀번호는 문자 및 숫자를 조합한 6자리 이상으로 구성해주세요.");
      setPassworeValid(false);
      return submitInput;
    } else {
      setEmptyinputs("");
      setPassworeValid(true);
    }

    if (isEmpty(pwchk)) {
      setModalOpen(true);
      setModalMsg("새 비밀번호 확인을 해주세요");
      setPassworeChkValid(false);
      return submitInput;
    } else if (password !== pwchk) {
      setModalOpen(true);
      setModalMsg("비밀번호가 일치하지 않습니다.");
      return submitInput;
    } else {
      setPassworeChkValid(true);
    }

    return true;
  };

  const editPost = () => {
    if (!checkEmptyInput()) {
    } else {
      editPostMemberPw();
    }
  };

  const editPostMemberPw = async () => {
    let data = await requestPost("/api/member/edit/password", {
      regInputs,
    });

    if (data.result) {
      setModalOpen(true);
      setModalKind("S");
      setModalMsg("비밀번호가 변경되었습니다.");
    } else {
      setModalOpen(true);
      setModalMsg("현재 비밀번호를 확인해주세요.");
    }
  };

  const msgModalConfirm = () => {
    if (modalKind === "S") {
      props.modalConfirm();
    }
    setModalOpen(false);
  };

  return (
    <div className="modalBackground">
      <div className="modalContainer-edit-password">
        <h2 id="font-SCD4">회원 비밀번호 변경</h2>
        <br></br>
        <div className="termsBody" id="font-SCD3">
          <div
            className="display-center-margin-0"
            style={{ padding: "0 10px" }}
          >
            <div className="">
              <div className="span-gray-text">
                <span className="">현재 비밀번호</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="password"
                name="nowPassword"
                value={nowPassword}
              ></input>
              {emptyinputs === "nowPassword" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">
                    현재 비밀번호를 입력해주세요
                  </span>
                </div>
              )}
            </div>

            <div className="">
              <div className="span-gray-text">
                <span className="">새 비밀번호</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="password"
                name="password"
                value={password}
              ></input>

              <div style={{ marginBottom: "20px", width: "98%" }}>
                <span className="span-gray-small-text">
                  ※ 문자 및 숫자를 조합한 6자리 이상으로 구성
                </span>
              </div>
              {emptyinputs === "pw" && (
                <div style={{ marginTop: "-20px", marginBottom: "15px" }}>
                  <span className="warning-text">비밀번호를 입력해주세요.</span>
                </div>
              )}
              {!passwordValid && (
                <div style={{ marginTop: "-20px", marginBottom: "15px" }}>
                  <span className="warning-text">
                    문자 및 숫자를 조합한 6자리 이상으로 구성해주세요.
                  </span>
                </div>
              )}
            </div>
            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">새 비밀번호 확인</span>
              </div>
              <input
                onChange={inputPwchk}
                className="input-form-w97p-40"
                type="password"
                name="pwchk"
                value={pwchk}
              ></input>

              {!passwordChkValid ? (
                <div style={{ marginTop: "-5px", marginBottom: "20px" }}>
                  <span className="warning-text-pw">
                    비밀번호 확인을 해주세요.
                  </span>
                </div>
              ) : pwchk === "" ? (
                <></>
              ) : password === pwchk ? (
                <div style={{ marginTop: "-5px", marginBottom: "20px" }}>
                  <span className="passing-text-pw">
                    비밀번호가 일치합니다.
                  </span>
                </div>
              ) : (
                <div style={{ marginTop: "-5px", marginBottom: "20px" }}>
                  <span className="warning-text-pw">
                    비밀번호가 일치하지 않습니다.
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="mfooter">
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              className="terms-agree"
              onClick={() => editPost()}
              id="font-SCD4"
            >
              비밀번호 변경
            </button>
            <button
              className="terms-cancel"
              onClick={() => props.setOpenModal(false)}
              id="font-SCD4"
            >
              취소
            </button>
          </div>
        </div>
      </div>
      {modalOpen && (
        <MsgModal
          setOpenModal={setModalOpen}
          modalMsg={modalMsg}
          modalConfirm={msgModalConfirm}
        ></MsgModal>
      )}
    </div>
  );
};

export default EditPasswordModal;
